import * as React from 'react';
import styled from 'styled-components';
import { Row } from '../../layout/Row';
import { ControlHelpText } from './ControlHelpText';
import { ControlLabel } from './ControlLabel';
import { SearchInput } from './SearchInput';

const ListControlContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 15px;
  padding-right: 10px;
  margin-top: 10px;
  align-items: center;
  margin-bottom: 5px;
`;

const SelectListHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const SelectListHeaderCell = styled.div`
  flex: 4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:last-child {
    flex: 2;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: flex-end;
  }
`;

interface IListControlLabelProps {
  label: string;
  helpText?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  searchValue?: string;
  onSearchHandler?: (term: string) => void;
  onSearchClearHandler?: () => void;
}

export const ListControlLabel = (
  props: IListControlLabelProps
): React.ReactElement => {
  return (
    <ListControlContainer style={props.style}>
      <SelectListHeaderCell>
        <Row>
          <ControlLabel>{props.label}</ControlLabel>
          <ControlHelpText>{props.helpText}</ControlHelpText>
        </Row>
        {props.onSearchHandler && (
          <SearchInput
            style={{ marginLeft: '0px' }}
            onChange={props.onSearchHandler}
            value={props.searchValue}
            onClear={props.onSearchClearHandler}
          />
        )}
      </SelectListHeaderCell>
      <SelectListHeaderCell>{props.children}</SelectListHeaderCell>
    </ListControlContainer>
  );
};
